import { BaseEventProps } from "../../types";

export enum ModuleEventProps {
  STABLE_ENTITY_ID = "Stable Entity ID",
  STABLE_ENTITY_TYPE = "Stable Entity Type",
  STABLE_ENTITY_ALERTS = "Stable Entity Alerts"
}

export type EventProps = BaseEventProps | ModuleEventProps;

export enum MediatorEventType {
  CLICK = "MY_STABLE_CLICK", // TODO: check if this is correct or need to be removed
  ENTITY_REMOVED = "MY_STABLE_ENTITY_REMOVED",
  ENTITY_SELECTED = "MY_STABLE_ENTITY_SELECTED",
  ALERTS_MODAL_OPENED = "MY_STABLE_ALERTS_MODAL_OPENED",
  ALERTS_APPLIED = "MY_STABLE_ALERTS_APPLIED",
  PP_MODAL_OPENED = "MY_STABLE_PP_MODAL_OPENED"
}

export interface EventData {
  payload: {
    entityId?: string;
    entityType?: string;
    linkName?: string;
    fullURL?: string;
    alerts?: unknown;
    module?: string;
  };
}
